import React, { createContext, useContext, useState, useEffect } from 'react';
import { getProjects } from '../services/api';

const ProjectsContext = createContext();

export const useProjects = () => {
  const context = useContext(ProjectsContext);
  if (!context) {
    throw new Error('useProjects must be used within a ProjectsProvider');
  }
  return context;
};

export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastFetch, setLastFetch] = useState(null);

  const loadProjects = async (force = false) => {
    // Avoid multiple calls within 30 seconds unless forced
    if (!force && lastFetch && Date.now() - lastFetch < 30000) {
      return projects;
    }

    try {
      setLoading(true);
      setError(null);
      
      const response = await getProjects();
      const projectsData = response.data.data;
      
      setProjects(projectsData);
      setLastFetch(Date.now());
      setLoading(false);
      
      return projectsData;
    } catch (err) {
      setError(err.message || 'Failed to load projects');
      setLoading(false);
      throw err;
    }
  };

  // Load projects on mount
  useEffect(() => {
    loadProjects();
  }, []);

  const value = {
    projects,
    selectedUnit,
    setSelectedUnit,
    selectedFloor,
    setSelectedFloor,
    loading,
    error,
    loadProjects,
    refreshProjects: () => loadProjects(true)
  };

  return (
    <ProjectsContext.Provider value={value}>
      {children}
    </ProjectsContext.Provider>
  );
};
